import { RootState } from '../../../applicationStore';
import { CustomersState } from '../reducers';
import { createSelector } from '@reduxjs/toolkit';

export const getCustomersState = (state: RootState): CustomersState =>
  state.customers;

export const getCustomersLoader = createSelector(
  getCustomersState,
  (state): boolean => state.loading,
);

export const getCustomersData = createSelector(
  getCustomersState,
  (state): CustomersState['data'] | null => state?.data || [],
);
